import React from 'react';
import { Nav, NavItem } from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap/lib';
import buildMenu from './menuBuilder';

function InternalDashboardNav() {
  const renderMenuItem = item => {
    const url = item.getUrl();
    return (
      <LinkContainer to={url} key={url}>
        <NavItem>{item.name}</NavItem>
      </LinkContainer>
    );
  };

  const menu = buildMenu();
  return <Nav bsStyle="tabs">{menu.map(renderMenuItem)}</Nav>;
}

export default InternalDashboardNav;
